import { axiosNodeInstance } from "../../../adapters/axiosInstance";
import { GET_WAREHOUSE_DETAILS } from "./warehouseTyepes";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getWarhouseDetails = createAsyncThunk(GET_WAREHOUSE_DETAILS, async () => {
    const response = await axiosNodeInstance.get("/storage/warehouse_details");
    return response.data;
});
